import React, { useContext, useEffect } from 'react';
import { useQuery, QueryClient, QueryClientProvider } from 'react-query';
import { DropdownItem, MenuAttributeProps, MenuAttributeTypes } from '../../modal/MenuAttribute';
import FormModal from '../../modal/FormModal';
import usStates from './states';
import { UserSessionDetails, UserSessionDetailsContext } from '../../App';

const queryClient = new QueryClient()

interface CountyAddModalProps {
    refreshTable: () => void;
    isOpen: boolean;
    closeModal: () => void;
}

const dropdown_options = usStates.map((state) => ({
    id: state.abbreviation,
    display: state.name
} as DropdownItem));

const CountyAddModal = (props: CountyAddModalProps): JSX.Element => (
    <QueryClientProvider client={queryClient}>
        <CountyAddModalInner {...props}/>
    </QueryClientProvider>
);

const CountyAddModalInner = (props: CountyAddModalProps): JSX.Element => {
    const sessionDetails: UserSessionDetails = useContext(UserSessionDetailsContext);
    const [nameValue, setNameValue] = React.useState('');
    const [stateCodeValue, setStateCodeValue] = React.useState({
        id: '',
        display: '',
    } as DropdownItem);

    const menuAttributes: MenuAttributeProps[] = [
        {
            name: "County Name",
            attributeType: MenuAttributeTypes.short_input,
            set_value: nameValue,
            setValue: setNameValue
        },
        {
            name: "State",
            attributeType: MenuAttributeTypes.dropdown_input,
            set_value: stateCodeValue,
            setValue: setStateCodeValue,
            dropdown_values: dropdown_options
        }
    ];

    // disabled if there exists a form element w/ length 0
    const isSaveButtonDisabled = (): boolean => nameValue.length === 0 || stateCodeValue.id.length !== 2;

    // submit request stuff
    const { data, status, refetch, remove } = useQuery('client_add', async () => {
        const res = await fetch(`${sessionDetails.backend.host}:${sessionDetails.backend.port}/county`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                access_token: sessionDetails.access_token,
                req: {
                    county_name: nameValue,
                    state_code: stateCodeValue.id
                }
            })
        });
        return res.json();
    }, { // options are here so it won't auto-fetch
        refetchOnWindowFocus: false,
        enabled: false, 
    });
    const loading = status !== 'success' || data.STATUS !== 'SUCCESS';

    const onSubmit = () => {
        refetch();
    }

    useEffect(() => {
        if (!loading) {
            setNameValue('');
            setStateCodeValue({
                id: '',
                display: '',
            });
            remove();
            props.closeModal();
            props.refreshTable();
        }
    }, [loading, props, remove]);
    
    return (
        <FormModal 
            title='Add County'
            form_strategy='Add'
            menuAttributes={menuAttributes}
            onClose={props.closeModal}
            isOpen={props.isOpen}
            isSaveButtonDisabled={isSaveButtonDisabled}
            onSave={onSubmit}
        />
    )
};

export default CountyAddModal;